export default "__VITE_ASSET__DWxhJ74M__"